//import '@master/css';
import './public.scss';

// max-age/secure/samesite 對齊 server 端 cookie：iOS 走 LINE App 授權再導回時，session cookie 會在情境切換中被丟掉，改為 10 分鐘持久 cookie 才能存活跨站導覽。.
document.cookie = "login_redirect_url=" + encodeURIComponent(window.location.href) + "; path=/; max-age=600; secure; samesite=Lax";

document.addEventListener("click", function (event) {
  var link = event.target.closest(".wc-notify-line-wrap a");
  if (!link) {
    return;
  }

  // 點擊 LINE 登入按鈕當下，在登入端點 URL 補一個 timestamp cache-buster。.
  // 讓每次點擊的 URL 都唯一，即使 CDN（Cloudflare 等）對 /wp-json/ 開了 Cache Everything，
  // 快取鍵也永遠不同 → 一定 cache miss → 每次都拿到新鮮的 state，避免共用過期 state 造成 Invalid state。.
  if (link.href.indexOf("_=") === -1) {
    var separator = link.href.indexOf("?") === -1 ? "?" : "&";
    link.href = link.href + separator + "_=" + Date.now();
  }

  // Blocksy 帳號彈窗（.ct-account-modal）在 capture 階段攔截 href 含 "login" 的連結，
  // 會 preventDefault 並切到登入分頁，導致 LINE 登入按鈕在彈窗內完全點不動。.
  // 僅在「彈窗內 + 單純左鍵點擊」時，改用 JS 強制跳轉：preventDefault 只能擋 <a> 的預設行為，
  // 程式化設定 location 不受影響，照常跳轉。.
  // 這裡刻意不用 stopPropagation，事件照常冒泡到 document，GTM／GA 等靠事件委派的點擊追蹤不受影響。.
  var inBlocksyModal =
    link.closest && link.closest(".ct-account-modal") !== null;
  var isPlainLeftClick =
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey;

  if (inBlocksyModal && isPlainLeftClick) {
    window.location.href = link.href;
  }
});
